
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../../store/modules/user';
import { productList } from '@/api/device';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';
import { makeKey } from '@/utils/qiniu';

import OrderAddressCustom from '../../order/components/OrderAddressCustom.vue';

@Component({
  name: 'DeviceDetail',
  components: {
    OrderAddressCustom
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogDeviceVisible!:Boolean;

  @Prop({
    type: Number,
    default: 1
  })deviceType!:Number;

  @Prop({
    type: Object,
    default: () => {}
  })deviceEditData?:any;

  private formDevice:any = {
    serial: '',
    sn: '',
    name: '',
    brand: {},
    product: {},
    model: {},
    buytime: '',
    describle: '',
    address: '',
    area: '',
    imageUrl: '',
    vendorName: '',
    vendorPhone: ''
  }

  // 选择品牌
  private brandList:any={}
  private productList:any={}
  private moduleList:any={}
  private deviceId = '';

  created() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_DEVICE
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });

    this.getBrand('', 1);
  }

  @Watch('deviceEditData', { deep: true, immediate: true })
  ondeviceTypeChange() {
    if (this.deviceType === 2) {
      this.formDevice = {
        serial: this.deviceEditData.number,
        sn: this.deviceEditData.sn,
        name: this.deviceEditData.name,
        brand: {},
        product: {},
        model: {},
        buytime: this.deviceEditData.buy_time ? new Date(this.deviceEditData.buy_time) : '',
        describle: this.deviceEditData.describe,
        address: this.deviceEditData.device_address,
        area: this.deviceEditData.device_area,
        imageUrl: this.deviceEditData.image_save_path,
        imgage_key: this.deviceEditData.save_parh_key,
        vendorName: this.deviceEditData.manufacturer_name,
        vendorPhone: this.deviceEditData.manufacturer_phone
      };
      this.formDevice.brand.id = this.deviceEditData.brand_id;
      this.formDevice.brand.name = this.deviceEditData.brand_name;
      this.formDevice.product.name = this.deviceEditData.product_name;
      this.formDevice.product.id = this.deviceEditData.product_id;
      this.formDevice.model.id = this.deviceEditData.model_id;
      this.formDevice.model.name = this.deviceEditData.model_name;
      if (this.deviceEditData.brand_id) {
        this.getBrand(this.deviceEditData.brand_id, 2);
      }
      if (this.deviceEditData.product_id) {
        this.getBrand(this.deviceEditData.product_id, 3);
      }
    } else {
      this.formDevice = {
        serial: '',
        sn: '',
        name: '',
        brand: {},
        product: {},
        model: {},
        buytime: '',
        describle: '',
        address: '',
        area: '',
        imageUrl: '',
        vendorName: '',
        vendorPhone: '' };
    }
  }

  private addDevice() {
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.brand_id = this.formDevice.brand.id;
    params.product_id = this.formDevice.product.id;
    params.model_id = this.formDevice.model.id;
    params.number = this.formDevice.serial;
    params.sn = this.formDevice.sn;
    params.name = this.formDevice.name;
    params.buy_time = this.formDevice.buytime / 1000;
    params.describe = this.formDevice.describle;
    params.device_address = this.formDevice.address;
    params.device_area = this.formDevice.area;
    params.image_save_path = this.formDevice.imgage_key;
    params.manufacturer_name = this.formDevice.vendorName;
    params.manufacturer_phone = this.formDevice.vendorPhone;

    this.$emit('deviceDialogOperat', params);
  }

  private getBrand(id:string, type:number) {
    let parameters:any = {};
    parameters.company_id = UserModule.getCompanyId;
    parameters.product_type = type;
    switch (type) {
      case 1:
        break;
      case 2:
        parameters.brand_id = id;
        break;
      case 3:
        parameters.brand_id = this.formDevice.brand.id;
        parameters.product_id = id;
        break;
    }

    productList(parameters).then(res => {
      switch (type) {
        case 1:
          if (res.data) {
            this.brandList = res.data.list;
          } else {
            this.brandList = [];
          }

          break;
        case 2:
          if (res.data) {
            this.productList = res.data.list;
          } else {
            this.productList = [];
          }

          break;
        case 3:
          if (res.data) {
            this.moduleList = res.data.list;
          } else {
            this.moduleList = [];
          }

          break;
      }
    }).catch(error => {
      let msg = error.msg;
    });
  }

  private brandChange(val:any) {
    this.formDevice.product = '';
    this.formDevice.model = '';
    if (val && val.id) {
      this.getBrand(val.id, 2);
    } else {
      this.productList = [];
    }
  }
  private productChange(val:any) {
    this.formDevice.model = '';
    if (val && val.id) {
      this.getBrand(val.id, 3);
    } else {
      this.moduleList = [];
    }
  }
  private moduleChange(val:any) {
    this.getBrand(this.formDevice.product.id, 3);
  }

  private addressCustomVisible = false
  private currentCompanyID = UserModule.getCompanyId;
  private isMultilevelRadio = true
  private selectDeviceAddressHandle() {
    this.addressCustomVisible = true;
  }
  private closeDeviceCustomHandle(value:boolean) {
    this.addressCustomVisible = value;
  }
  private saveDeviceCustomHandle(value: any) {
    this.addressCustomVisible = false;
    let oneAddress, twoAddress, threeAddress;
    if (value) {
      if (value.pBean && value.pBean1) {
        oneAddress = JSON.parse(value.pBean).address;
        twoAddress = JSON.parse(value.pBean1).address;
        threeAddress = value.address;
      } else if (value.pBean) {
        oneAddress = JSON.parse(value.pBean).address;
        twoAddress = value.address;
        threeAddress = '';
      } else {
        oneAddress = value.address;
        twoAddress = '';
        threeAddress = '';
      }
    }
    this.formDevice.address = oneAddress + twoAddress + threeAddress;
  }

  // 上传图片
  private qiniu: any;
  private action = 'https://up-z1.qiniup.com';
  private form: object = {};
  handleAvatarSuccess(res: any, file: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.formDevice.imageUrl = imgUrl;
    this.formDevice.imgage_key = res.key;
  }
  beforeAvatarUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }
  deleteImgHandle() {

  }

  private confirmDevice() {
    this.addDevice();
    // this.close();
  }

  private close() {
    this.$emit('close', false);
  }
}
